import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./../../styles/accueil/MesCommandes.css";

function MesCommandes() {
  const [commandes, setCommandes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [client, setClient] = useState({});

  // ✅ Fonction pour formater les prix (remplacer / par .)
  const formatPrix = (valeur) => {
    if (!valeur) return "0 Ar";
    return Number(valeur).toLocaleString("fr-FR").replace(/\//g, ".") + " Ar";
  };

  // ✅ Fonction pour générer le PDF
  const genererPDF = (commande) => {
    console.log("Commande à exporter :", commande);
    const doc = new jsPDF();

    // 🟢 Titre principal
    doc.setFontSize(18);
    doc.setTextColor(21, 128, 61);
    doc.text("Historique de la commande", 105, 15, { align: "center" });

    // 🟢 Informations sur le client
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    doc.text(`Nom du client : ${client.name || "—"} ${client.firstname || ""}`, 14, 30);
    doc.text(`Email : ${client.email || "—"}`, 14, 38);
    doc.text(`Entreprise : ${client.company || "Ma Société"}`, 14, 46);

    // 🟢 Infos commande
    const ligneCommande = 54;
    doc.text(`Commande n°: ${commande.id}`, 14, ligneCommande);
    doc.text(
      `Date: ${
        commande.date_paiement
          ? new Date(commande.date_paiement).toLocaleDateString("fr-FR")
          : "—"
      }`,
      14,
      ligneCommande + 8
    );
    doc.text(`Référence: ${commande.reference || "—"}`, 14, ligneCommande + 16);
    doc.text(
      `Montant total: ${formatPrix(commande.montant)}`,
      14,
      ligneCommande + 24
    );

    // 🟢 Tableau produits
    const tableColumn = [
      "Produit",
      "Catégorie",
      "Quantité",
      "Unité",
      "Prix unitaire",
    ];
    const tableRows = [];

    if (commande.produits && commande.produits.length > 0) {
      commande.produits.forEach((p) => {
        const prodData = [
          p.titre || "Produit",
          p.categorie || "—",
          p.quantite || 1,
          p.unite || "",
          formatPrix(p.prix_unitaire),
        ];
        tableRows.push(prodData);
      });
    }

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 90,
      theme: "grid",
      headStyles: { fillColor: [21, 128, 61] },
      styles: { fontSize: 10 },
    });

    // 🟢 Téléchargement du PDF
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `commande_${commande.id}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // 🟢 Récupération des commandes du client
  useEffect(() => {
    const fetchCommandes = async () => {
      try {
        const clientData = JSON.parse(localStorage.getItem("clientConnecte")) || {};
        setClient(clientData);

        if (!clientData.email) {
          setMessage("Client non connecté.");
          setLoading(false);
          return;
        }

        const res = await fetch(
          `http://localhost:5000/api/commande/client/${clientData.email}`
        );
        const data = await res.json();

        if (res.ok) {
          const toutes = data.sort(
            (a, b) =>
              new Date(b.date_paiement || b.createdAt) -
              new Date(a.date_paiement || a.createdAt)
          );
          setCommandes(toutes);
        } else {
          setMessage("Erreur lors du chargement de l'historique.");
        }
      } catch (err) {
        console.error(err);
        setMessage("Erreur lors du chargement de l'historique.");
      } finally {
        setLoading(false);
      }
    };

    fetchCommandes();

    const handleClientUpdated = () => {
      setLoading(true);
      fetchCommandes();
    };

    window.addEventListener("clientUpdated", handleClientUpdated);
    return () => {
      window.removeEventListener("clientUpdated", handleClientUpdated);
    };
  }, []);

  if (loading) return <p className="loading">Chargement...</p>;

  return (
    <div className="historique-container">
      <h2 className="historique-title">📜 Historique</h2>

      {message && <p className="message-erreur">{message}</p>}

      {commandes.length === 0 && !message ? (
        <p className="aucun-historique">Aucun historique trouvé.</p>
      ) : (
        commandes.map((cmd) => (
          <div key={cmd.id} className="commande-card">
            <div className="commande-header">
              <h3>Commande n°{cmd.id}</h3>
              <span className="commande-date">
                {cmd.date_paiement
                  ? new Date(cmd.date_paiement).toLocaleDateString("fr-FR")
                  : "—"}
              </span>
            </div>

            <div className="commande-details">
              <p>
                <strong>Client :</strong> {client.name || "—"} {client.firstname || ""}
              </p>
              <p>
                <strong>Entreprise :</strong> {client.company || "Ma Société"}
              </p>
              <p>
                <strong>Référence :</strong> {cmd.reference || "—"}
              </p>
              <p>
                <strong>Montant total :</strong> {formatPrix(cmd.montant)}
              </p>
            </div>

            <h4 className="produits-titre">Produits :</h4>
            <ul className="produits-list">
              {cmd.produits && cmd.produits.length > 0 ? (
                cmd.produits.map((p, i) => (
                  <li key={i} className="produit-item">
                    <span className="produit-nom">
                      {p.titre || "Produit"} ({p.categorie || "—"})
                    </span>{" "}
                    — {p.quantite || 1} {p.unite || ""} × {formatPrix(p.prix_unitaire)}
                  </li>
                ))
              ) : (
                <li className="produit-item vide">
                  Aucun produit trouvé pour cette commande.
                </li>
              )}
            </ul>

            {/* 🟢 Bouton PDF */}
            <button
              style={{
                marginTop: "10px",
                padding: "6px 12px",
                backgroundColor: "#15803d",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => genererPDF(cmd)}
            >
              📄 Télécharger PDF
            </button>
          </div>
        ))
      )}
    </div>
  );
}

export default MesCommandes;
